import React, { useEffect, useState } from 'react';
import Navbar from '../Shared/Navbar';
import { useSendPasswordResetEmail, useSignInWithEmailAndPassword } from "react-firebase-hooks/auth";
import { useForm } from 'react-hook-form';
import { FaUser, FaLock, FaAngleDoubleRight } from 'react-icons/fa';
import logoW from '../../assets/tripaide-logo-w.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { auth } from '../../firebase.init';
import useUsers from '../../hooks/useUsers';

const SignIn = () => {

    const [users] = useUsers();

    const [userInfo, setUserInfo] = useState({
        email: "",
        password: "",
    });

    const [signInWithEmail, user, loading, hookError] = useSignInWithEmailAndPassword(auth);
    const [sendPasswordResetEmail, sending, error] = useSendPasswordResetEmail(auth);

    const { register, handleSubmit } = useForm();

    const handleEmail = e => {
        setUserInfo({ ...userInfo, email: e.target.value });
    };
    const handlePass = e => {
        setUserInfo({ ...userInfo, password: e.target.value });
    };

    const onSubmit = () => {
        const currentUser = users?.filter(u => u?.email === userInfo.email);
        if (currentUser[0]?.role === "blocked") {
            toast.error("Sorry! You're blocked.");
        } else {
            signInWithEmail(userInfo.email, userInfo.password);
        }
    };

    useEffect(() => {
        const err = hookError || error;
        if (err) {
            //console.log(hookError?.message);
            switch (err?.code) {
                case "auth/wrong-password":
                    toast.error("Wrong password. Intruder!!")
                    break;
                case "auth/user-not-found":
                    toast.error("Email is not registered.")
                    break;
                default:
                    toast.error(err.code.slice(err.code.indexOf('/') + 1))
            }
        }
    }, [hookError || error]);


    // const getToken = async (admin) => {
    //     const email = admin?.user?.email;
    //     //console.log(email);
    //     if (email) {
    //         const { data } = await axios.post('https://wood-peckers.herokuapp.com/signin', { email });
    //         localStorage.setItem('accessToken', data.accessToken);
    //         //console.log(localStorage);
    //     }
    // };

    // if (googleUser || user) {
    //     const admin = googleUser || user;
    //     getToken(admin);
    // }

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/home";

    useEffect(() => {
        // console.log(googleUser);
        if (user) {
            navigate(from, { replace: true });
        }
    }, [user]);

    const handleForgotPass = () => {
        if (userInfo.email !== "") {
            sendPasswordResetEmail(userInfo.email);
            if (!sending) {
                toast.warning("Password reset link was sent to your mail.");
            }
        } else {
            toast.error("Please enter your email!");
        }
    };

    return (
        <div>
            <Navbar />
            <div className='flex flex-col items-center'>
                <div className='2xl:w-3/5 flex flex-col xl:flex-row mx-8 my-16 md:mx-32 border-2 rounded-lg'>
                    <div className='flex flex-col justify-center px-8 py-16 rounded-lg login-bg text-center text-white'>
                        <div className='flex flex-col items-center'>
                            <img className='block w-1/2' src={logoW} alt="main logo" />
                            <p>A Social Media From Travellers</p>
                        </div>
                        <div className='py-8 flex flex-col items-center'>
                            <p className='text-lg font-semibold'>Nice to see you again!</p>
                            <h1 className='text-4xl md:text-6xl font-bold'>Welc<span className='border-b-4'>ome </span>Back</h1>
                            <p className='mt-8 lg:mt-16 xl:w-3/5'>What's the fun in travelling alone? Let's find your perfect tour partners, guides, packages and many more!</p>
                        </div>
                    </div>
                    <div className='p-12 lg:py-24'>
                        <h1 className='text-2xl font-bold text-center text-yellow-500 mt-4'>Please Sign In</h1>
                        <p className='my-4'>By filling up your login credentials to sign in to your account to further proceed into tripaide.</p>
                        <form onSubmit={handleSubmit(onSubmit)} className=''>
                            <div onChange={handleEmail} className='flex py-4'>
                                <span className='block p-4 bg-gray-200 text-white border-r-2 border-white rounded-l-lg'><FaUser className='block' /></span>
                                <input required type='email' className='block w-full px-4 bg-gray-200 text-gray-900 rounded-r-lg' {...register("email", { maxLength: 30 })} placeholder="Email Address" />
                            </div>
                            <div onChange={handlePass} className='flex py-4'>
                                <span className='block p-4 bg-gray-200 text-white border-r-2 border-white rounded-l-lg'><FaLock className='block' /></span>
                                <input required type='password' minLength="8" className='block w-full px-4 bg-gray-200 text-gray-900 rounded-r-lg' {...register("password", { minLength: 8 })} placeholder="Your Password" />
                            </div>
                            <div className='flex justify-between'>
                                <div className='flex'>
                                    <input type="checkbox" className='mr-2 checked:bg-blue-500' />
                                    <p className='font-semibold'>Keep Me Signed In</p>
                                </div>
                                <div className='mr-4'>
                                    <a className='text-red-600 font-semibold cursor-pointer' onClick={handleForgotPass}>Forgot Password?</a>
                                </div>
                            </div>
                            <button className='block w-full mt-4 bg-yellow-500 text-lg font-bold text-gray-900 hover:shadow-lg px-3 py-2 rounded-md font-semibold cursor-pointer' type="submit">
                                Sign In <FaAngleDoubleRight className='ml-1 inline-block' />
                            </button>
                        </form>
                        <div className='flex font-semibold mt-8'>
                            <p>New to tripaide?</p>
                            <Link to='/signup' className='ml-4 text-lg text-yellow-500 cursor-pointer'>Create An Account</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignIn;